import { getAPI } from "../utils/api";
import endpoints from "../utils/endpoints";

export const getDashboardStats = (callBack, errorCallback) => {
  return () => {
    getAPI(
      endpoints?.GET_DASHBOARD_STATS,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem("token")
    );
  };
};

export const getDashboardRecentUsers = (callBack, errorCallback) => {
  return () => {
    getAPI(
      endpoints?.GET_DASHBOARD_RECENT_USERS,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem("token")
    );
  };
};

export const getDashboardRecentTransactions = (callBack, errorCallback) => {
  return () => {
    getAPI(
      endpoints?.GET_DASHBOARD_RECENT_TRANSACTIONS,
      {},
      (data) => {
        callBack(data);
      },
      (err) => {
        errorCallback(err);
      },
      localStorage.getItem("token")
    );
  };
};
